import type { WorkerManager } from '../../../../worker';
import { FeaturePreviewExecution } from '../FeaturePreviewExecution';
import type { ExtrudeFeatureDefinitionModel } from '../../../definition/extrude/ExtrudeFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';

/**
 * 拉伸特征预览执行器。
 */
export class ExtrudePreviewExecution extends FeaturePreviewExecution<ExtrudeFeatureDefinitionModel> {
    /** Worker 管理器。 */
    private readonly workerManager: WorkerManager;

    /**
     * @param workerManager Worker 管理器。
     */
    public constructor(workerManager: WorkerManager) {
        super();
        this.workerManager = workerManager;
    }

    /**
     * @inheritdoc
     */
    public async executeCreatePreview(definition: ExtrudeFeatureDefinitionModel): Promise<WorkerFeaturePreviewResult> {
        return this.workerManager.generateExtrudePreview(definition.getCommandParams());
    }

    /**
     * @inheritdoc
     */
    public async executeEditPreview(
        session: FeatureEditSession<ExtrudeFeatureDefinitionModel>,
        definition: ExtrudeFeatureDefinitionModel,
    ): Promise<WorkerFeaturePreviewResult> {
        const originalCommands = session.getOriginalCommands();
        const targetIndex = originalCommands.findIndex((command) => command.id === session.getTargetCommand().id);
        // 凸台终止条件只对创建位置之前求值，后续无强依赖实体也不能扩大贯穿范围。
        const commands = definition.getFeatureKind() === 'boss-extrude'
            ? originalCommands.slice(0, targetIndex)
            : session.getPreviewCommands();
        return this.workerManager.generateExtrudePreviewInSandbox({
            commands,
            params: definition.getCommandParams(),
        });
    }
}
